import { render, staticRenderFns } from "./updateRecord.vue?vue&type=template&id=1d518a00&scoped=true"
import script from "./updateRecord.vue?vue&type=script&lang=js"
export * from "./updateRecord.vue?vue&type=script&lang=js"
import style0 from "./updateRecord.vue?vue&type=style&index=0&id=1d518a00&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d518a00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d518a00')) {
      api.createRecord('1d518a00', component.options)
    } else {
      api.reload('1d518a00', component.options)
    }
    module.hot.accept("./updateRecord.vue?vue&type=template&id=1d518a00&scoped=true", function () {
      api.rerender('1d518a00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/updateRecord.vue"
export default component.exports